import React, { useEffect, useRef, useState } from 'react';

import styles from './ShadeBackground.module.scss';

type Props = {
  colors?: string[];
};

export function ShadeBackground(props: Props) {
  const ref = useRef<HTMLDivElement>();
  const [measures, setMeasures] = useState({ height: 0, width: 0 });

  useEffect(() => {
    setMeasures({
      height: ref.current.clientHeight,
      width: ref.current.clientWidth,
    });
  }, []);

  const size = measures.width / props.colors.length;

  return (
    <div className={styles.absoluteContainer}>
      <div className={styles.container} ref={ref}>
        {props.colors.map((color, index) => (
          <div
            key={index}
            className={styles.circle}
            style={{
              marginTop: index % 2 === 0 ? measures.height / 2.5 : -(measures.height / 4.5),
              backgroundColor: color,
              height: size,
              width: size,
              filter: `blur(${size * 0.66}px)`,
            }}
          />
        ))}
      </div>
    </div>
  );
}

ShadeBackground.defaultProps = {
  colors: ['#357BFF', '#FFD7AE', '#7AD330', '#FF7436'],
};
